import React from 'react';
import { C, S } from '../../utils/styles';
import Icon from '../Icon';
import EligibilityAdvisor from '../EligibilityAdvisor';

export default function IncreaseSavingsSection({ client, analyzed, config }) {
  const employees = client?.employees || [];
  const hasAnalysis = employees.length > 0 && analyzed && analyzed.length > 0;

  if (!hasAnalysis) {
    // Hidden per spec until analysis exists
    return null;
  }

  return (
    <div data-testid="increase-savings-section" style={{ ...S.card, padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
        <Icon name="sparkles-outline" style={{ fontSize: 20, color: C.green }} />
        <h2 style={{ fontSize: 16, fontWeight: 800, color: C.text, margin: 0, letterSpacing: '-0.01em', textTransform: 'uppercase' }}>
          Increase Your Savings
        </h2>
      </div>
      <p style={{ fontSize: 12, color: C.textMid, margin: '0 0 14px 2px' }}>
        Actions you can take to qualify more employees
      </p>

      {/* Reuse the existing EligibilityAdvisor with mode="employer" */}
      <EligibilityAdvisor
        employees={employees}
        analyzed={analyzed}
        config={config}
        mode="employer"
      />
    </div>
  );
}
